package gr.tech.GRAttestation.sections.tables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.browser.dom.ElementTarget
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.overlay.KeepPopupOpenStrategy
import com.varabyte.kobweb.silk.components.overlay.PopupPlacement
import com.varabyte.kobweb.silk.components.overlay.Tooltip
import com.varabyte.kobweb.silk.components.overlay.onHover
import com.varabyte.kobweb.silk.components.text.SpanText
import gr.tech.GRAttestation.models.activity.ActivityDTO
import gr.tech.GRAttestation.navigation.AdminSitePage
import gr.tech.GRAttestation.sections.admin.AdminTableContainer
import gr.tech.GRAttestation.util.TimeUtils.formatDateOnly
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun AdminActivityTable(
    activities: List<ActivityDTO>,
) {
    AdminTableContainer() {
        Table(
            attrs = Modifier
                .classNames("table")
                .minWidth(1000.px)
                .height(100.percent)
                .fillMaxWidth()
                .toAttrs()
        ) {
            Thead(
                attrs = Modifier
                    .styleModifier {
                        property("table-layout", "fixed")
                    }
                    .toAttrs()
            ) {
                Tr {
                    Th(
                        attrs = Modifier.minWidth(75.px).classNames("col").toAttrs()
                    ) { Text("ID")}
                    Th(
                        attrs = Modifier.minWidth(350.px).classNames("col").toAttrs()
                    ) { Text("Activity")}
                    listOf(
                        "User",
                        "User ID",
                        "Created",
                        "User Agent",
                        "IP",
                        "Store",
                        "Attestation",
                        "SKU",
                    ).forEach { header ->
                        Th(
                            attrs = Modifier.minWidth(125.px).classNames("col").toAttrs()
                        ) { Text(header) }
                    }
                }
            }
            Tbody {
                if (activities.isNotEmpty()) {
                    activities.forEach { activity ->
                        AdminActivityTableRow(
                            activity = activity,
                        )
                    }
                } else {
                    repeat(2) {
                        AdminActivitySummaryRow(null)
                    }
                }
            }
        }
    }
}


@Composable
fun AdminActivityTableRow(
    activity: ActivityDTO,
) {
    Tr {
        Td { Text(activity.id.toString()) }
        Td { Text(activity.activity) }
        Td { Text(activity.userIdentity) }
        Td(
            attrs = Modifier.maxWidth(200.px).overflow(Overflow.Hidden)
                .textOverflow(TextOverflow.Ellipsis).whiteSpace(WhiteSpace.NoWrap).toAttrs()
        ) {
            SpanText(
                text = activity.userUUID ?: "-",
                modifier = Modifier
            )
            activity.userUUID?.let { id ->
                Tooltip(
                    target = ElementTarget.Parent,
                    modifier = Modifier.padding(4.px).maxWidth(200.px),
                    placement = PopupPlacement.Top,
                    hasArrow = true,
                    showDelayMs = 50,
                    hideDelayMs = 50,
                    keepOpenStrategy = KeepPopupOpenStrategy.onHover()
                ) { Text(activity.userUUID) }
            }
        }
        Td {
            Span { Text(formatDateOnly(activity.createdAt)) }
            TableDateTimeTooltip(activity.createdAt)
        }
        Td(
            attrs = Modifier.maxWidth(200.px).overflow(Overflow.Hidden)
                .textOverflow(TextOverflow.Ellipsis).whiteSpace(WhiteSpace.NoWrap).toAttrs()
        ) {
            SpanText(
                text = activity.userAgent,
                modifier = Modifier
            )
            Tooltip(
                target = ElementTarget.Parent,
                modifier = Modifier.padding(4.px).maxWidth(150.px).zIndex(2),
                placement = PopupPlacement.Top,
                hasArrow = true,
                showDelayMs = 50,
                hideDelayMs = 50,
            ) { Text(activity.userAgent) }
        }
        Td { Text(activity.ipAddress) }
        Td {
            if (activity.storeId != null) {
                Link(
                    path = AdminSitePage.Stores.passStoreId(activity.storeId.toString()),
                    text = "${activity.storeId}"
                )
            } else {
                Text("-")
            }
        }
        Td { Text((activity.formId ?: "-").toString()) }
        Td { Text((activity.skuId ?: "-").toString()) }
    }
}